// loader.interceptors.ts
import { Injectable } from "@angular/core";
import {
  HttpErrorResponse,
  HttpResponse,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { LoaderService } from "./loader.service";
import { SweetAlertHelper } from "../_helpers/sweet.alert.helper";
import { Message } from "../_locale/messages";
import { async } from "@angular/core/testing";
@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];
  message = Message;
  showLoader = false;
  constructor(
    private loaderService: LoaderService,
    public sweetAlertHelper: SweetAlertHelper
  ) {}

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.loaderService.isLoading.next(this.requests.length > 0);
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.requests.push(req);
    this.loaderService.isLoading.next(true);
    return Observable.create((observer) => {
      const subscription = next.handle(req).subscribe(
        (event) => {
          if (event instanceof HttpResponse) {
            this.removeRequest(req);
            observer.next(event);
          }
        },
        async (err) => {
          // alert('error returned');
          this.showLoader = false;
          const alertStatus = await this.sweetAlertHelper.alertPopUp(
            this.message.alertMessages.httpintercepterserviceComp.intercept
          );
          this.showLoader = false;
          if(alertStatus){
            window.location.reload()
          }
          this.removeRequest(req);
          observer.error(err);
        },
        () => {
          this.removeRequest(req);
          observer.complete();
        }
      );
      // remove request from queue when cancelled
      return () => {
        this.removeRequest(req);
        subscription.unsubscribe();
      };
    });
  }
}
